<template>
  <quick-tips :tips="tips"/>
</template>

<script>
import QuickTips from '@/components/QuickTips.vue';

export default {
  components: {
    QuickTips,
  },
  data() {
    return {
      tips: [],
    };
  },
  created() {
    this.tips = [
      {
        header: 'Person Type Details',
        body: [
          `The user can turn the person type status from Active to Inactive or 
          vice-versa by clicking the edit icon.`,
        ],
      },
      {
        header: 'Person Type: Active Status',
        body: [
          `The person type must be active for the system to accept data records 
          with the specific person type code in the person type field in the detail 
          record format on the submission file. For example, for Student Person Type, 
          the person type code Student (02) must be active to submit records with 02 in 
          the Person Type field on the detail submission records.`,
        ],
      },
      {
        header: 'Person Type: Inactive Status',
        body: [
          `Turning a person type status to Inactive will prohibit the system from accepting 
          records with the inactive person type code such as 02 for student, 03 for staff or 
          04 Higher Ed in the Person Type Field in the detail submission record.`,
        ],
      },
    ];
  },
};
</script>

<style lang="sass" scoped>
</style>
